import { Ghost, Skull, Candy, Moon } from "lucide-react";
import { Reveal } from "./Reveal";

const FLOATERS = [
  { Icon: Ghost, label: "100% MEME POWERED", color: "text-[#B6FF00]", border: "border-[#B6FF00]/40", pos: "-top-5 -left-4", delay: "0s" },
  { Icon: Skull, label: "ZERO BORING PROMISES", color: "text-[#FF6B00]", border: "border-[#FF6B00]/40", pos: "-bottom-6 -right-3", delay: "1.4s" },
  { Icon: Candy, label: "PURE HALLOWEEN ENERGY", color: "text-[#A020F0]", border: "border-[#A020F0]/40", pos: "top-1/2 -right-8", delay: "2.2s" },
];

export const About = () => (
  <section id="about" className="relative z-10 py-20 lg:py-32 px-4 sm:px-8" data-testid="about-section">
    <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="mono text-xs tracking-[0.35em] text-[#A020F0] glow-purple mb-4">// THE LORE</p>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl leading-tight" data-testid="about-title">
            <span className="text-[#FF6B00] glow-orange">TRICK OR TREAT?</span>
            <br />
            <span className="text-[#B6FF00] glow-green">WE CHOOSE WIN.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 space-y-5 text-purple-100/85 text-base sm:text-lg leading-relaxed max-w-xl">
            <p>
              Every Halloween, the world gets spooky. But this year, something different is haunting Solana.
            </p>
            <p>
              Meet <span className="text-[#FF6B00] font-bold">$HALLOWIN</span>.
            </p>
            <p>
              Born from memes, powered by the community, and fueled by pure Halloween energy.
            </p>
            <p>
              No boring promises. No complicated stories.
            </p>
            <p className="text-[#B6FF00] font-bold">
              Just pumpkins, memes, and the ultimate Halloween degen experience.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-8 flex items-center gap-3 mono text-xs tracking-[0.25em] text-purple-300/60">
            <Moon className="w-4 h-4 text-[#A020F0]" />
            EST. SPOOKY SEASON · SOLANA BLOCKCHAIN
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="lg:col-span-5">
        <div className="relative mx-auto w-fit" data-testid="about-visual">
          <div className="absolute inset-0 -m-8 rounded-full bg-[#A020F0]/25 blur-3xl" />
          <div className="relative rounded-3xl border-2 border-[#A020F0]/50 p-3 bg-[#19002E]/60 backdrop-blur-md rotate-2 hover:rotate-0 transition-transform duration-500 shadow-[0_0_40px_rgba(160,32,240,0.3)]">
            <img
              src="/mascot.jpg"
              alt="HALLOWIN pumpkin in a witch hat, pointing at you"
              className="rounded-2xl w-72 sm:w-80 lg:w-96 animate-flicker"
            />
          </div>
          {FLOATERS.map(({ Icon, label, color, border, pos, delay }, i) => (
            <div
              key={i}
              className={`absolute ${pos} flex items-center gap-2 bg-[#080808]/90 backdrop-blur border ${border} rounded-full px-4 py-2 animate-float`}
              style={{ animationDelay: delay }}
            >
              <Icon className={`w-4 h-4 ${color}`} />
              <span className="mono text-[10px] tracking-[0.2em] text-white whitespace-nowrap">{label}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
